// @ts-ignore
window.ReactOnRails = window.ReactOnRails || require('react-on-rails').default;

import './shared-api';

import React, { Suspense } from 'react';
import Header from '@/components/Header';
import CallManager from '@/components/CallManagerApp';

// App component gets registered on every app route,
// but its code will only download once it is rendered on one of the React routes
const LazyApp = React.lazy(() => import(/* webpackPrefetch: true */'@/components/App'));
const App = (props: React.ComponentProps<typeof LazyApp>) =>
  React.createElement(Suspense, { fallback: null }, React.createElement(LazyApp, props));

// @ts-ignore
window.ReactOnRails.register({ Header, App, CallManager });
